import { Grid, Button } from '@mui/material';
import { maxdepartmentAndPhysiciansAllowed } from '../../../settings/appConfig';
import Panel from '../../../components/UI/Panel';
import useFormatPhone from '../../../hooks/UI/usePhonesHelperMethods';
import GenericInput from './UI/GenericInput';
import useUI from '../../../hooks/context/useUI';
import useValidation from '../../../hooks/validation/useValidation';
import { Add } from '@mui/icons-material';

export default function FacilityDepartmentAndPhysiciansInfo({
  formik,
  showPanel,
}: Readonly<{
  formik: any;
  showPanel: boolean;
}>) {
  const { formatPhoneNumberOnChange } = useFormatPhone();

  const { isdepartmentAndPhysiciansValid } = useValidation();
  const { showSnackbar } = useUI();

  const onAddNewDepartmentPhysicians = async () => {
    if (isdepartmentAndPhysiciansValid(formik.values.departmentAndPhysicians) || formik?.values?.departmentAndPhysicians?.length === 0) {
      const newItems = [
        ...formik.values.departmentAndPhysicians,
        {
          department: '',
          additionalInformation: '',
          phoneNumber: '',
          name: '',
        },
      ];
      formik.setFieldValue('departmentAndPhysicians', newItems);
    } else {
      showSnackbar(['Please enter a valid contact'], 'error');
    }
  };

  const content = (
    <Grid container spacing={2} mx={1} px={1}>
      {formik?.values?.departmentAndPhysicians?.length > 0 &&
        formik?.values?.departmentAndPhysicians?.map((item: any, index: number) => (
          <Grid my={2} container key={item.id}>
            <Grid item xs={4} px={2}>
              <GenericInput
                name={`departmentAndPhysicians.${index}.department`}
                label="Department"
                maxLength={120}
                placeholder="Department"
                value={item.department}
                onChange={(e: any) => {
                  formik.setFieldValue(
                    `departmentAndPhysicians.${index}.department`,
                    e.target.value,
                  );
                }}
                errorMsg={
                  formik.touched.departmentAndPhysicians?.[index]?.['department'] &&
                    formik.errors.departmentAndPhysicians?.[index]?.['department']
                    ? formik.errors.departmentAndPhysicians[index]['department']
                    : ''
                }
                hasError={
                  !!(formik.touched.departmentAndPhysicians?.[index]?.['department'] &&
                    formik.errors.departmentAndPhysicians?.[index]?.['department'])
                }
                onBlur={() => {
                  formik.setFieldTouched(`departmentAndPhysicians.${index}.department`, true);
                }}
              />
            </Grid>
            <Grid item xs={4} px={2}>
              <GenericInput
                name={`departmentAndPhysicians.${index}.name`}
                label="Name"
                maxLength={120}
                placeholder="Name"
                value={item.name}
                onChange={(e: any) => {
                  formik.setFieldValue(
                    `departmentAndPhysicians.${index}.name`,
                    e.target.value,
                  );
                }}
                errorMsg={
                  formik.touched.departmentAndPhysicians?.[index]?.['name'] &&
                    formik.errors.departmentAndPhysicians?.[index]?.['name']
                    ? formik.errors.departmentAndPhysicians[index]['name']
                    : ''
                }
                hasError={
                  !!(formik.touched.departmentAndPhysicians?.[index]?.['name'] &&
                    formik.errors.departmentAndPhysicians?.[index]?.['name'])
                }
                onBlur={() => {
                  formik.setFieldTouched(`departmentAndPhysicians.${index}.name`, true);
                }}
              />
            </Grid>
            <Grid item xs={4} px={2}>
              <GenericInput
                name={`departmentAndPhysicians.${index}.phoneNumber`}
                label="Phone"
                maxLength={12}
                placeholder="xxx-xxx-xxxx"
                inputMode="tel"
                value={item.phoneNumber}
                onChange={(e: any) => {
                  formatPhoneNumberOnChange(e);
                  formik.setFieldValue(
                    `departmentAndPhysicians.${index}.phoneNumber`,
                    e.target.value,
                  );
                }}
                errorMsg={
                  formik.touched.departmentAndPhysicians?.[index]?.['phoneNumber'] &&
                    formik.errors.departmentAndPhysicians?.[index]?.['phoneNumber']
                    ? formik.errors.departmentAndPhysicians[index]['phoneNumber']
                    : ''
                }
                hasError={
                  !!(formik.touched.departmentAndPhysicians?.[index]?.['phoneNumber'] &&
                    formik.errors.departmentAndPhysicians?.[index]?.['phoneNumber'])
                }
                onBlur={() => {
                  formik.setFieldTouched(`departmentAndPhysicians.${index}.phoneNumber`, true);
                }}
              />
            </Grid>
            <Grid item xs={4} px={2} my={2}>
              <GenericInput
                name={`departmentAndPhysicians.${index}.additionalInformation`}
                label="Additional Information"
                maxLength={80}
                placeholder="Additional Information"
                value={item.additionalInformation}
                onChange={(e: any) => {
                  formik.setFieldValue(
                    `departmentAndPhysicians.${index}.additionalInformation`,
                    e.target.value,
                  );
                }}
                errorMsg={
                  formik.touched.departmentAndPhysicians?.[index]?.['additionalInformation'] &&
                    formik.errors.departmentAndPhysicians?.[index]?.['additionalInformation']
                    ? formik.errors.departmentAndPhysicians[index]['additionalInformation']
                    : ''
                }
                hasError={
                  !!(formik.touched.departmentAndPhysicians?.[index]?.['additionalInformation'] &&
                    formik.errors.departmentAndPhysicians?.[index]?.['additionalInformation'])
                }
                onBlur={() => {
                  formik.setFieldTouched(`departmentAndPhysicians.${index}.additionalInformation`, true);
                }}
              />
            </Grid>
            <Grid item xs={3} px={1} my={2}>
              {formik.values.departmentAndPhysicians.length > 1 && (
                <Button
                  type="button"
                  onClick={() => {
                    const newItems = [...formik.values.departmentAndPhysicians];
                    newItems.splice(index, 1);
                    formik.setFieldValue('departmentAndPhysicians', [...newItems]);
                  }}
                >
                  Remove
                </Button>
              )}

              {index === formik.values.departmentAndPhysicians.length - 1 &&
                formik.values.departmentAndPhysicians.length < maxdepartmentAndPhysiciansAllowed && (
                  <Button
                    type="button"
                    onClick={onAddNewDepartmentPhysicians}
                    startIcon={<Add />}
                  >
                    Add Other Department/Physicians
                  </Button>
                )}
            </Grid>
          </Grid>
        ))}
    </Grid>
  );
  return (
    <>
      {showPanel === true && (
        <Panel headerText="Department/Physicians">{content}</Panel>
      )}
      {!showPanel && content}
    </>
  );
}

FacilityDepartmentAndPhysiciansInfo.defaultProps = {
  showPanel: true,
};
